/**
 * EstadosFinancieros.js — página contenedora con tabs
 * Ruta: /finanzas/estados?tab=XXXX
 * Cada tab carga el componente existente como contenido.
 */
import { useLocation, useNavigate } from "react-router-dom";
import BalanceComprobacion from "./BalanceComprobacion";
import EstadoResultados    from "./EstadoResultados";
import BalanceGeneral      from "./BalanceGeneral";
import EstadoFinanciero    from "./EstadoFinanciero";

const TABS = [
  {
    id:        "balance-comprobacion",
    label:     "Balance de Comprobación",
    icon:      "fa-scale-balanced",
    component: BalanceComprobacion,
  },
  {
    id:        "estado-resultados",
    label:     "Estado de Resultados",
    icon:      "fa-chart-line",
    component: EstadoResultados,
  },
  {
    id:        "balance-general",
    label:     "Balance General",
    icon:      "fa-building-columns",
    component: BalanceGeneral,
  },
  {
    id:        "estado-financiero",
    label:     "Estado Financiero",
    icon:      "fa-file-pdf",
    component: EstadoFinanciero,
  },
];

export default function EstadosFinancieros() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab = new URLSearchParams(location.search).get("tab") ?? TABS[0].id;
  const activeTab  = TABS.find(t => t.id === currentTab) ?? TABS[0];
  const ActiveComp = activeTab.component;

  function goTab(id) {
    navigate(`/finanzas/estados?tab=${id}`, { replace: true });
  }

  return (
    <div>
      {/* ── Tab bar ── */}
      <div style={{
        display: "flex",
        gap: 4,
        borderBottom: "1px solid #364250",
        marginBottom: 24,
        flexWrap: "wrap",
      }}>
        {TABS.map(tab => {
          const active = tab.id === currentTab;
          return (
            <button
              key={tab.id}
              onClick={() => goTab(tab.id)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 7,
                padding: "10px 18px",
                background: active ? "rgba(249,115,22,0.12)" : "transparent",
                border: "none",
                borderBottom: active ? "2px solid #f97316" : "2px solid transparent",
                color: active ? "#f97316" : "#9ca3af",
                fontWeight: active ? 700 : 400,
                fontSize: "0.85rem",
                cursor: "pointer",
                transition: "all 0.15s",
                whiteSpace: "nowrap",
                borderRadius: "6px 6px 0 0",
              }}
              onMouseOver={e => {
                if (!active) e.currentTarget.style.color = "#e5ecf5";
              }}
              onMouseOut={e => {
                if (!active) e.currentTarget.style.color = "#9ca3af";
              }}
            >
              <i className={`fa-solid ${tab.icon}`} style={{ fontSize: "0.8rem" }} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* ── Contenido del tab activo ── */}
      <ActiveComp />
    </div>
  );
}
